import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'

import { HaeMoniyritystukiPyynto, HaeMoniyritystukiVastaus, Moniyritystuki } from 'app/_jaettu-lemonator/model/moniyritys'
import { FirebaseLemonator } from '../service/firebase-lemonator.service'

export interface MoniyritystukiComponentData {
  /** null = uusi moniyritystuki */
  tuki: Moniyritystuki | null
}

@Injectable()
export class MoniyritystukiComponentDataResolve implements Resolve<MoniyritystukiComponentData> {
  private existingData: MoniyritystukiComponentData = null

  constructor(private _firebase: FirebaseLemonator) {}

  asetaOlemassaolevaData(data: MoniyritystukiComponentData) {
    this.existingData = data
  }

  resolve(route: ActivatedRouteSnapshot): Promise<MoniyritystukiComponentData> {
    const avain = route.params['tukiAvain']
    return this._annaTuki(avain).then(tuki => ({ tuki: tuki }))
  }

  private async _annaTuki(avain: string): Promise<Moniyritystuki | null> {
    if (avain === 'uusi') {
      return null
    }
    if (this.existingData?.tuki?.avain === avain) {
      return this.existingData.tuki
    }
    const vastaus = await this._firebase.functionsCall<HaeMoniyritystukiPyynto, HaeMoniyritystukiVastaus>('moniyritystuki-hae', { tukiAvain: avain })
    return vastaus?.tuki ?? null
  }
}
